const teamMembers = document.querySelectorAll('.team-member[data-gif-src]');
const isHoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
const mobileMembers = new Map();
const GIF_DISPLAY_MS = 4000;

teamMembers.forEach((member) => {
    const wrapper = member.querySelector('.team-member__image');
    const gifImg = member.querySelector('.team-member__gif');
    const gifSrc = member.dataset.gifSrc;

    if (!wrapper || !gifImg || !gifSrc) {
        return;
    }

    let isLoaded = false;
    let hideTimeout = null;
    let isPlaying = false;

    function loadGif() {
        if (isLoaded) {
            return Promise.resolve();
        }

        return new Promise((resolve) => {
            gifImg.onload = () => {
                isLoaded = true;
                resolve();
            };
            gifImg.onerror = () => {
                isLoaded = true;
                resolve();
            };
            gifImg.src = gifSrc;
        });
    }

    function showGif() {
        loadGif().then(() => {
            wrapper.classList.add('is-gif-active');
        });
    }

    function hideGif() {
        clearTimeout(hideTimeout);
        hideTimeout = null;
        isPlaying = false;
        wrapper.classList.remove('is-gif-active');
    }

    function showGifTimed() {
        if (isPlaying) {
            return;
        }

        isPlaying = true;

        loadGif().then(() => {
            wrapper.classList.add('is-gif-active');
            clearTimeout(hideTimeout);
            hideTimeout = setTimeout(hideGif, GIF_DISPLAY_MS);
        });
    }

    if (isHoverDevice) {
        wrapper.addEventListener('mouseenter', showGif);
        wrapper.addEventListener('mouseleave', hideGif);
    } else {
        mobileMembers.set(wrapper, { showGif: showGifTimed, hideGif });
    }
});

if (!isHoverDevice && mobileMembers.size) {
    const mobileObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const handlers = mobileMembers.get(entry.target);

            if (!handlers) {
                return;
            }

            if (entry.isIntersecting && entry.intersectionRatio >= 1) {
                handlers.showGif();
            } else {
                handlers.hideGif();
            }
        });
    }, {
        threshold: 1,
    });

    mobileMembers.forEach((_, wrapper) => {
        mobileObserver.observe(wrapper);
    });
}
